module.exports = __webpack_public_path__ + "img/but10.63dbed22.png";